import styled from '@emotion/styled';

import colors from 'resources/styles/colors';

export const ListingStack = styled.div`
  display: flex;
  flex: 1;
  align-items: stretch;
  gap: 1rem;
  min-height: 0;
  margin-top: 1rem;
`;

export const ReportDetailViewportWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
`;

export const ReportViewRoutes = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
`;

export const ReportViewport = styled.div<{ $isFullscreen?: boolean }>`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  padding-top: ${({ $isFullscreen }) => ($isFullscreen ? '0' : '0.75rem')};

  ${({ $isFullscreen }) => $isFullscreen && `
    position: fixed;
    inset: 0;
    z-index: 2000;
    width: 100vw;
    height: 100vh;
    min-height: 100vh;
    margin: 0;
    background-color: white;
  `}
`;

export const ReportPreviewArea = styled(ReportViewport)``;

export const REPORT_VIEW_CONTROL_BORDER_RADIUS = '4px';
export const REPORT_VIEW_CONTROL_HEIGHT = '38px';

export const ReportViewHeaderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const ReportViewToggleButton = styled.button`
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${REPORT_VIEW_CONTROL_HEIGHT};
  height: ${REPORT_VIEW_CONTROL_HEIGHT};
  min-width: ${REPORT_VIEW_CONTROL_HEIGHT};
  padding: 0;
  border: 1px solid ${colors.gray};
  border-radius: ${REPORT_VIEW_CONTROL_BORDER_RADIUS};
  background-color: white;
  color: ${colors.primaryColor};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  cursor: pointer;

  &:hover {
    background-color: ${colors.lightGray};
  }

  &:focus-visible {
    outline: 2px solid ${colors.primaryColor};
    outline-offset: 2px;
  }
`;

export const ReportFullscreenExitButton = styled(ReportViewToggleButton)`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 1;
  opacity: 0.4;
  transition: opacity 120ms ease-in-out;

  &:hover,
  &:focus-visible {
    opacity: 1;
  }
`;
